import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Biblioteca.css';

function Biblioteca() {
  const [arquivos, setArquivos] = useState([]);
  const [arquivo, setArquivo] = useState(null);
  const [loading, setLoading] = useState(false);

  const carregarBiblioteca = async () => {
    try {
      const res = await axios.get('https://welaunchyou.com.br/crm-wly/api/openai/listar_biblioteca.php', { withCredentials: true });
      setArquivos(res.data);
    } catch (err) {
      console.error('Erro ao listar biblioteca', err);
    }
  };

  const handleUpload = async () => {
    if (!arquivo) return alert("Selecione um arquivo.");
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    setLoading(true);

    try {
      await axios.post('https://welaunchyou.com.br/crm-wly/api/openai/upload_pdf.php', formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setArquivo(null);
      carregarBiblioteca();
    } catch (err) {
      alert('Erro ao fazer upload');
    } finally {
      setLoading(false);
    }
  };

  const handleDeletar = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir esse PDF?")) return;
    try {
      await axios.post('https://welaunchyou.com.br/crm-wly/api/openai/deletar_arquivo.php', { id }, { withCredentials: true });
      carregarBiblioteca();
    } catch (err) {
      alert('Erro ao excluir PDF');
    }
  };

  useEffect(() => {
    carregarBiblioteca();
  }, []);

  return (
  <div className="biblioteca-container">
    <p>Os arquivos enviados aqui servem EXCLUSIVAMENTE para alimentar a inteligência das respostas do Agente IA.<br></br>NÃO SERVEM PARA SEREM ENVIADOS PARA O CONTATO, para envio para seu contato use a aba "Materia de envio".</p>

    <div className="biblioteca-upload">
      <input
        type="file"
        accept=".pdf"
        onChange={(e) => setArquivo(e.target.files[0])}
      />

      <button onClick={handleUpload} className="biblioteca-botao">
        {loading ? 'Enviando...' : 'Enviar PDF'}
      </button>
    </div>

    <div>
      {arquivos.length === 0 ? (
        <p>Nenhum PDF enviado ainda.</p>
      ) : (
        <ul className="biblioteca-lista">
          {arquivos.map((arq) => (
            <li key={arq.id} className="biblioteca-item">
              <div>
                <strong>{arq.nome_arquivo}</strong>
                <br />
                <small>Enviado em: {arq.data_envio}</small>
              </div>
              <button
                onClick={() => handleDeletar(arq.id)}
                className="biblioteca-excluir"
              >
                Excluir
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

}

export default Biblioteca;
